module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbnMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ4IDQyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzM0MzQzNDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmNoYXRBcnRib2FyZCAxPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00NywwSDFBMSwxLDAsMCwwLDAsMVYzM2ExLDEsMCwwLDAsMSwxSDE0djdhMSwxLDAsMCwwLDEuNzEuNzFMMjMuNDEsMzRINDdhMSwxLDAsMCwwLDEtMVYxQTEsMSwwLDAsMCw0NywwWk0xMSwxMEgyOWExLDEsMCwwLDEsMCwySDExYTEsMSwwLDAsMSwwLTJaTTM3LDI0SDExYTEsMSwwLDAsMSwwLTJIMzdhMSwxLDAsMCwxLDAsMlptMC02SDExYTEsMSwwLDAsMSwwLTJIMzdhMSwxLDAsMCwxLDAsMloiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-chat.svg
// module id = 569
// module chunks = 1